const initialState = { data: null, loading: true };

export const GetProjectsCOAMaxLevelReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_projects_coa_max_level":
      return {
        data: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};
